import React, { useState, useEffect, useCallback } from "react";
import styles from "./CurrencyConverter.module.scss";
import { useInView } from "react-cool-inview";

export default function CurrencyConverter({
  sourceCurrency = "USD",
  targetCurrency = "EUR",
}) {
  const [sourceAmount, setSourceAmount] = useState(100);

  const { observe, inView } = useInView({ unobserveOnEnter: true });

  const malfunctioningCurrencies = ["DJF"];

  const generateWiseCurrencyConverter = useCallback(() => {
    const callToActionLabel = "Get started";
    const hideCta = false;
    const hideDetails = true;
    const affiliateLink = "https://wise.prf.hn/click/camref:1011lqT3E";
    const lang = "en";
    const width = "98%";
    const height = "490px";
    /* Do not modify the code below */
    const redirectUrlParams = encodeURIComponent(
      "https://wise.com?sourceCurrencyCode=" +
        sourceCurrency +
        "&targetCurrencyCode=" +
        targetCurrency +
        "&fromCalcWidget=true&sourceAmount=" +
        sourceAmount
    );
    const redirectUrl = encodeURIComponent(
      affiliateLink + "?u=" + redirectUrlParams
    );

    const wiseIframeUrl = `https://wise.com/gb/currency-converter/fx-widget/converter?sourceCurrency=${sourceCurrency}&targetCurrency=${targetCurrency}&amount=${sourceAmount}&ctaVariant=GET_STARTED&ctaLink=https%3A%2F%2Fwise.com%2F%3Fclickref%3D1011lyC7QGFe%26partnerID%3D1100l258231%26utm_medium%3Daffiliate%26utm_campaign%3D0%26adref%3D%26utm_source%3Dwherenext%26partnerizecampaignID%3D1101l644`;

    // const wiseIframeUrl =
    //   "https://wise.com/widget/calculator?sourceCurrencyCode=" +
    //   sourceCurrency +
    //   "&targetCurrencyCode=" +
    //   targetCurrency +
    //   "&amount=" +
    //   sourceAmount +
    //   "&cta=" +
    //   callToActionLabel +
    //   "&hideCta=" +
    //   hideCta +
    //   "&hideDetails=" +
    //   hideDetails +
    //   "&redirectUrl=" +
    //   redirectUrl +
    //   "&lang=" +
    //   lang +
    //   "&theme=light";

    const iframe = React.createElement(
      "iframe",
      {
        title: "fx",
        width,
        height,
        id: "wise-calc",
        scrolling: "no",
        frameBorder: "0",
        allowTransparency: "true",
        src: wiseIframeUrl,
        key: targetCurrency,
      },
      []
    );

    return iframe;
  }, [sourceCurrency, targetCurrency, sourceAmount]);

  return (
    <div id="wise-calc-widget" className={`${styles.container}`} ref={observe}>
      {inView &&
        !malfunctioningCurrencies?.includes(sourceCurrency) &&
        !malfunctioningCurrencies?.includes(targetCurrency) &&
        generateWiseCurrencyConverter()}
    </div>
  );
}
